<template>
  <component :is="topBarComponent" v-bind="$attrs" />
</template>

<script lang="ts" setup>
defineOptions({ inheritAttrs: false });

const themeStyleStore = useThemeStyleStore();

const themedTopBars = import.meta.glob('../Theme/*/Layout/TopBar.vue');
const defaultTopBar = defineAsyncComponent(
  () => import('../Theme/Default/Layout/TopBar.vue'),
);

const topBarComponent = computed(() => {
  const themedTopBarPath = `../Theme/${themeStyleStore.frame}/Layout/TopBar.vue`;
  const themedTopBar = themedTopBars[themedTopBarPath];

  return themedTopBar ? defineAsyncComponent(themedTopBar) : defaultTopBar;
});
</script>
